import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { StatusType } from 'commons/types';
import { hasFeatureEnabledAction, SubscriptionsSelector } from '../../redux';

interface Attributes {
  status: StatusType;
  hasFeatureEnabled: boolean;
  fetchHasFeatureEnabled: () => void;
}

export function useHasSubscriptionsFeatureEnabled(): Attributes {
  const dispatch = useAppDispatch();
  const hasFeatureEnabled = useSelector(
    SubscriptionsSelector.hasFeatureEnabled,
  );
  const status = useSelector(SubscriptionsSelector.hasFeatureEnabledStatus);

  const fetchHasFeatureEnabled = useCallback(() => {
    dispatch(hasFeatureEnabledAction());
  }, [dispatch]);

  return {
    status,
    hasFeatureEnabled,
    fetchHasFeatureEnabled,
  };
}
